import React from "react";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#09090b] border-t border-white/5 pt-24 pb-10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12 pb-20 border-b border-white/10">
          <div className="md:col-span-6">
            <div className="mb-6">
              <img
                src="/brand/fina-logo.png"
                alt="Fina Engineering"
                className="h-16 md:h-20 w-auto object-contain"
              />
            </div>
            <p className="text-white/60 font-body max-w-md leading-relaxed">
              Precision welding and fabrication for the UK's food, pharma and
              water industries. Built in Lincolnshire since 2015.
            </p>
          </div>

          <div className="md:col-span-2">
            <div className="overline mb-5">— Company</div>
            <ul className="space-y-3 text-white/70 font-body text-sm">
              <li>About</li>
              <li>Services</li>
              <li>Quality</li>
              <li>Careers</li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="overline mb-5">— Sectors</div>
            <ul className="space-y-3 text-white/70 font-body text-sm">
              <li>Food production</li>
              <li>Pharmaceuticals</li>
              <li>Water</li>
              <li>Infrastructure</li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="overline mb-5">— Get in touch</div>
            <ul className="space-y-3 text-white/70 font-body text-sm">
              <li>01427 615913</li>
              <li>Lincolnshire, UK</li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 pt-8">
          <p className="text-white/40 text-xs font-body">
            © {year} Fina Engineering Ltd — All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-white/40 text-xs font-body">
            <span>Registered in England</span>
            <span>•</span>
            <span>ISO-aligned quality</span>
          </div>
        </div>

        <div
          aria-hidden
          className="pointer-events-none select-none mt-10 overflow-hidden"
        >
          <h2 className="font-heading text-white/5 text-[22vw] leading-none tracking-[-0.05em] whitespace-nowrap">
            FINA
          </h2>
        </div>
      </div>
    </footer>
  );
};
